import { ActivityStatus, ActivityUIKind } from "../../types";
import type { ActivityViewData } from "../../types";
import type { DatabaseAdapter } from "@rapid/providers/database/DatabaseAdapter";
import type { ActivityEventProvider, FirestoreActivityEvent } from "./types";

function toDate(ts: any): Date {
    return ts?.toDate?.() ?? new Date();
}

interface CIModelChangeEnrichment {
    workflowName?: string;
}

export const ciModelChangeProvider: ActivityEventProvider = {
    uiKind: ActivityUIKind.CIModelChange,

    convert(event: FirestoreActivityEvent, enrichment?: CIModelChangeEnrichment): ActivityViewData {
        return {
            id: event.id,
            kind: ActivityUIKind.CIModelChange,
            contextLabel:
                (event.payload?.contextLabel as string) || enrichment?.workflowName || undefined,
            title: (event.payload?.title as string) || "Model updated",
            description: (event.payload?.description as string) || null,
            status: ActivityStatus.Completed,
            icon: "far fa-sparkles",
            targetUrl:
                (event.payload?.targetUrl as string) ||
                `/redirect/id/${event.entity.id}?step=model`,
            openInNewTab: false,
            progress: null,
            error: null,
            createdAt: toDate(event.createdAt),
            completedAt: toDate(event.updatedAt)
        };
    },

    subscribeToEnrichment(
        event: FirestoreActivityEvent,
        onData: (data: CIModelChangeEnrichment) => void,
        database: DatabaseAdapter
    ): () => void {
        if (event.payload?.contextLabel) {
            return () => {};
        }

        let unsubWorkflow: (() => void) | null = null;

        const unsubRapidData = database.onSnapshot(
            "rapid_data",
            event.entity.id,
            (doc) => {
                const workflowId = doc.data()?.workflowId as string | undefined;
                if (!workflowId) return;

                unsubWorkflow?.();
                unsubWorkflow = database.onSnapshot(
                    "workflows",
                    workflowId,
                    (wfDoc) => {
                        const name = wfDoc.data()?.name as string | undefined;
                        if (name) {
                            onData({ workflowName: name });
                        }
                    },
                    () => {}
                );
            },
            () => {}
        );

        return () => {
            unsubRapidData();
            unsubWorkflow?.();
        };
    }
};
